.form {
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 18px;
  padding: 34px;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* "Attention" callout, pinned at the top of the form (flex gap handles the spacing below it). */
.warn {
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 16px;
  padding: 18px 22px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-primary-sand-900); /* text-2 */
  background: var(--color-secondary-yellow-200); /* SECONDARY_YELLOW_200 */
}

.warn strong {
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  font-weight: 800;
}

.warn a {
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* Bold-theme inputs, layered on top of the Plume field components. The Plume inputs ship a 1px sand
   border that data-theme="contrast" does NOT change, so we override the rendered controls here (scoped
   descendant selectors, no owl-kit mutation). Matches the design: 2px sand border, 10px radius, blue
   focus ring. `.form input` (0,1,1) outranks Plume's single-class input styles (0,1,0). */
.form input,
.form select,
.form textarea {
  width: 100%;
  height: auto;
  padding: 13px 16px;
  font-family: inherit;
  font-size: 15px;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: 2px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  border-radius: 10px;
}

.form textarea {
  min-height: 120px;
  resize: vertical;
}

.form input:focus,
.form select:focus,
.form textarea:focus {
  outline: none;
  /* full `border` shorthand so the 2px width holds on focus (Plume's :focus sets a 1px border) */
  border: 2px solid var(--color-primary-blue-500); /* blue-500 */
  box-shadow: 0 0 0 3px var(--color-primary-blue-100); /* blue-100 focus ring */
}

.req {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

.hint {
  font-size: 14px; /* copy-s */
  line-height: 1.55;
  color: var(--color-text-tertiary); /* text-3 */
  margin: 0;
}

.privacy {
  font-size: 11px;
  line-height: 1.5;
  color: var(--color-text-tertiary); /* text-3 */
  margin: 0;
}

.privacy a {
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
  font-weight: 600;
}
